module.exports = __webpack_public_path__ + "static/img/model-answer.fa6811c.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/model-answer.png
// module id = nrWV
// module chunks = 36